import { render, staticRenderFns } from "./RiskConferenceSafetyUpdate.vue?vue&type=template&id=cd288580&scoped=true&"
import script from "./RiskConferenceSafetyUpdate.vue?vue&type=script&lang=js&"
export * from "./RiskConferenceSafetyUpdate.vue?vue&type=script&lang=js&"
import style1 from "./RiskConferenceSafetyUpdate.vue?vue&type=style&index=1&id=cd288580&prod&lang=scss&scoped=true&"
import style2 from "./RiskConferenceSafetyUpdate.vue?vue&type=style&index=2&id=cd288580&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd288580",
  null
  
)

export default component.exports